import PrestationForm from "@features/creation/prestations/components/PrestationForm";
import { requirePermission } from "@lib/permissions/guards";
import { PERMISSIONS } from "@lib/permissions/permissions.generated";
import { createFileRoute } from "@tanstack/react-router";
import { PlusCircle } from "lucide-react";

export const Route = createFileRoute("/_app/creation/prestations/create")({
  loader: requirePermission(PERMISSIONS.CREATION.PRESTATIONS.CREATE),
  staticData: {
    title: "Nouvelle prestation",
    icon: PlusCircle,
    permission: PERMISSIONS.CREATION.PRESTATIONS.CREATE,
    section: "Creation",
    showInBreadcrumb: true,
  },
  component: CreatePrestationPage,
});

function CreatePrestationPage() {
  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">Nouvelle prestation</h1>
        <p className="text-sm text-base-content/60">Créer une nouvelle prestation</p>
      </div>
      <PrestationForm />
    </div>
  );
}
